import { connect } from 'react-redux';
import AddBetslip from '../../../components/views/AddBetslip';
import { viewEnter, addSlip } from '../../../modules/slip/actions';
import { isAddDisabled } from '../../../modules/slip/selectors';
import { getFieldErrors } from '../../FormMessage/selectors';

const mapStateToProps = state => ({
  externalErrors: getFieldErrors(state),
  addDisabled: isAddDisabled(state)
});

const mapDispatchToProps = {
  viewEnter,
  addNewBetslip: addSlip
};

export default connect(mapStateToProps, mapDispatchToProps)(AddBetslip);
